import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import EditorialModule from 'dibs-editorial-module/exports/EditorialModule';

import styles from './SharedWordpressArticles.scss';

const SharedWordpressArticlesComponent = ({ itemSearch }) => {
    const editorialArticles = itemSearch?.editorialArticles;
    if (!editorialArticles?.totalResults) {
        return null;
    }
    return (
        <div className={styles.container}>
            <EditorialModule editorialArticles={editorialArticles} />
        </div>
    );
};

SharedWordpressArticlesComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SharedWordpressArticles = createFragmentContainer(SharedWordpressArticlesComponent, {
    itemSearch: graphql`
        fragment SharedWordpressArticles_itemSearch on ItemSearchQueryConnection {
            editorialArticles(first: 2) {
                totalResults
                ...EditorialModule_editorialArticles
            }
        }
    `,
});
